import { useOperatingSystem } from '@studio/react-utils/user-agent';
import type { T_Nullable } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Hints } from './constants.js';
import { KeyCap } from './key-cap.jsx';
import type { Props } from './types.js';
import { toGlyphs } from '#~/hot-keys/index.js';

/** `<Combo>` component. */
export const Combo = ({ className, combo, ...props }: Props): T_Nullable<ReactElement> => {
  const glyphs = toGlyphs(useOperatingSystem(), combo);

  if (!glyphs) {
    return null;
  }

  return (
    <div className={twMerge('flex gap-4', className)} {...props}>
      {glyphs.map((glyph) => (
        <KeyCap glyph={glyph} key={glyph} title={Hints[glyph] ?? `${glyph} Key`} />
      ))}
    </div>
  );
};

/** `<Root>` alias. */
export const Root = Combo;
